<template>
    <div>
        <div class="aup-input-text" :class="{ 'aup-input-text--prefixed': prefix, 'aup-input-text--error': error, 'aup-input-text--suffixed': $slots.suffix }">
            <slot/>
            <div v-if="prefix" class="pl-3 aup-input-text__prefix">error:call:54</div>
            <input
                ref="input"
                :id="inputId || null"
                :value="displayValue"
                @input="handleInput"
                :maxlength="maxLength > 0 ? maxLength : false"
                class="aup-input-text__input w-100"
                :class="{ 'px-3': !noPadding }"
                :placeholder="placeholder"
                :disabled="isDisabled"
                :type="type"
                :aria-describedby="describedBy || null"
				:required="required"/>
            <label
                :for="inputId || null"
                class="aup-input-text__label aup-input-textarea__label--field-label t-heavy t-micro text-uppercase px-2">error:call:55</label>
            <div v-if="$slots.suffix" class="aup-input-text__suffix">
                <slot name="suffix"/>
            </div>
            <div
                class="aup-input-text__label aup-input-textarea__label--length t-heavy t-micro text-uppercase px-2"
                v-if="maxLength">error:call:56
            </div>
        </div>
        <p class="aup-input-error t-micro text-danger mt-1 mb-0 pl-3" v-if="error">error:call:57</p>
    </div>
</template>

<script>
    export default {
        name: 'BaseInput',
        props: {
            label: {
                type: String,
                default: 'Label'
            },
            type: {
                type: String,
                default: 'text'
            },
            placeholder: {
                type: String,
                default: ''
            },
            maxLength: {
                type: Number,
                default: 0
            },
            noPadding: {
                type: Boolean,
                default: false
            },
            value: {
                default: '',
                required: true
            },
            prefix: {
                type: String,
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
			required: {
				type: Boolean,
				default: false
			},
            // 'remaining' shows "72", 'total' shows "8 / 80"
            counterFormat: {
                type: String,
                default: 'remaining'
            },
            inputId: {
                type: String,
                default: ''
            },
            describedBy: {
                type: String,
                default: ''
            }
        },
        data() {
            const initial = this.value == null ? '' : String(this.value);
            return {
                charCount: initial.length
            };
        },
        watch: {
            value: {
                immediate: true,
                handler(val) {
                    this.charCount = this.toInputString(val).length;
                }
            }
        },
        computed: {
            displayValue() {
                return this.toInputString(this.value);
            }
        },
        methods: {
            toInputString(val) {
                return val == null ? '' : String(val);
            },
            handleInput(event) {
                const value = event.target.value;
                this.charCount = value.length;
                this.$emit('input', value);
            },
            focus() {
                if (this.$refs.input) {
                    this.$refs.input.focus();
                }
            }
        }
    };
</script>

<style lang="scss">
    @import "../../assets/scss/all";

    .aup-input-text {
        position: relative;

        &__label {
            position: absolute;
            background: $sony-white;

            &--field-label {
                top: 0;
                transform: translateY(-50%);
                left: 7px;
            }

            &--length {
                bottom: 0;
                transform: translateY(20%);
                right: 2%;
            }
        }

        &__input {
            border: 1px $gray-500 solid;
            padding-top: .75rem;
            padding-bottom: .75rem;

            &:focus {
                outline: none;
                box-shadow: 0 1px 0 $primary inset,
                0 -1px 0 $primary inset,
                -1px 0 0 $primary inset,
                1px 0 0 $primary inset;
            }

            &::placeholder {
                color: $gray-500;
            }

            &:disabled {
                background-color: transparent;
                border-color: $gray-500;
                color: $gray-700;

                & + label {
                    color: $gray-500;
                }
            }
        }

        &__prefix {
            border: 1px $gray-500 solid;
            border-right: none;
            color: $gray-500;
            padding-top: .75rem;
            padding-bottom: .75rem;
            line-height: 1.3;
        }

        &--error {
            color: red;

            > input, .aup-input-text__prefix {
                border-color: red;
            }
        }

        &__suffix {
            position: absolute;
            top: 50%;
            right: 4px;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
        }

        &--suffixed &__input {
            padding-right: 48px !important;
        }
    }

    //Fix for empty input type=date height on iOS and grey background on android
    .aup-input-text__input[type="date"] {
        min-height: 3rem;
        background-color:white
    }

    .aup-input-text--prefixed {
        display: flex;

        // On phones the prefix (e.g. the full profile URL) is wider than the field and pushed the
        // input outside it, so it couldn't be tapped. The prefix now shrinks with an ellipsis and
        // the input keeps room to type.
        .aup-input-text__prefix {
            flex: 0 1 auto;
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .aup-input-text__input {
            flex: 1 1 0;
            min-width: 8rem;
            border-left: none;
            padding-left: 0 !important;
            line-height: 1.3;
        }

        &:focus-within {
            .aup-input-text__input {
                outline: none;
                box-shadow: 0 1px 0 $primary inset,
                0 -1px 0 $primary inset,
                -1px 0 0 $primary inset;
            }

            .aup-input-text__prefix {
                box-shadow: 0 1px 0 $primary inset,
                0 -1px 0 $primary inset,
                1px 0 0 $primary inset;
            }
        }
    }

    .aup-input-error {
        margin-top: -1rem;
        margin-bottom: 1rem;
    }
</style>
